import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import Loader from 'components/Shared/Loader';
import UtilisateurSearch from 'components/Shared/UtilisateurSearch';

class ObservateursDialog extends React.Component {

    handleChangeUtilisateur = (id, codePO, nom, prenom) => {
        const { onChangeUtilisateur } = this.props;

        let error = null;
        if (id <= 0) {
            error = { key: 'utilisateur', errorMsg: 'Utilisateur requis' };
        }

        onChangeUtilisateur(id, codePO, nom, prenom, error);
    }

    getAvatarText = (observateur) => {
        // Priorité : code représentant > codePO > initiales nom/prénom
        if (observateur.codeRepresentant) {
            return observateur.codeRepresentant;
        }
        if (observateur.codePO) {
            return observateur.codePO;
        }
        return `${observateur.nom.charAt(0)}${observateur.prenom ? observateur.prenom.charAt(0) : observateur.nom.charAt(1)}`;
    }

    render() {
        let { open, onClose, observateurs, isLoading, editionAutorisee, onAddObservateur, onDeleteObservateur, namespace } = this.props;

        // Trier les observateurs par priorité : responsable -> représentant -> autres
        const observateursTries = [...observateurs].sort((a, b) => {
            // Priorité 1: En charge du litige
            if (a.roleLitige === 'En charge' && b.roleLitige !== 'En charge') return -1;
            if (b.roleLitige === 'En charge' && a.roleLitige !== 'En charge') return 1;
            
            // Priorité 2: Représentant du litige
            if (a.roleLitige === 'Representant' && b.roleLitige !== 'Representant' && b.roleLitige !== 'En charge') return -1;
            if (b.roleLitige === 'Representant' && a.roleLitige !== 'Representant' && a.roleLitige !== 'En charge') return 1;
            
            // Ordre alphabétique pour les autres
            return (a.nom + a.prenom).localeCompare(b.nom + b.prenom);
        });

        return (
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
                maxWidth={'sm'}
                PaperProps={{
                    sx: { maxHeight: '50vh' }
                }}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Liste des observateurs
                        {!editionAutorisee && (
                            <Tooltip title="Seul l'utilisateur affecté, un pilote ou administrateur du groupe affecté peut modifier la liste des observateurs d'un dossier après-vente.">
                                <LockIcon color="disabled" />
                            </Tooltip>
                        )}
                    </Box>
                </DialogTitle>
                <DialogContent sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: '100%'
                }}>

                    {editionAutorisee && (
                        <React.Fragment>
                            <Box sx={{
                                display: 'flex',
                                width: 'inherit',
                                marginTop: '8px',
                                minWidth: '400px'
                            }}>
                                <UtilisateurSearch
                                    namespace={namespace}
                                    error={undefined}
                                    onChange={this.handleChangeUtilisateur}
                                    isRequired={false}
                                />
                                <IconButton onClick={onAddObservateur} size="large"><AddIcon /></IconButton>
                            </Box>
                            <Divider sx={{ mt: 2, mb: 2, width: '100%' }} />
                        </React.Fragment>
                    )}

                    {isLoading
                        ? <Loader />
                        : (observateursTries.map((x, index) => (
                            <Box key={index} sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: 'inherit'
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <Avatar sx={{ m: 1 }}>{this.getAvatarText(x)}</Avatar>
                                    <Box>
                                        <Typography>{x.prenom} {x.nom}</Typography>
                                        {x.roleLitige && (
                                            <Typography variant="caption" color="primary">
                                                {x.roleLitige === 'En charge' ? 'En charge du litige' :
                                                 x.roleLitige === 'Representant' ? `ATC` : ''}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                                {editionAutorisee && <IconButton onClick={() => onDeleteObservateur(x.id)} size="large"><CloseIcon /></IconButton>}
                            </Box>
                        )))
                    }
                </DialogContent>
            </Dialog>
        );
    }
}

ObservateursDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    observateurs: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    editionAutorisee: PropTypes.bool.isRequired,
    onChangeUtilisateur: PropTypes.func.isRequired,
    onAddObservateur: PropTypes.func.isRequired,
    onDeleteObservateur: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
}

export default ObservateursDialog;